import Dashboard from "../../../../common/components/layout/Dashboard";
import Toast from "../../../../common/components/ui/toast";
import { ToastProvider } from "../../../../common/components/ui/toast/toast.provider";
import CampaignsTable from "./CampaignsTable.tsx"

function CampaignsPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <CampaignsTable />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default CampaignsPage;
